var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.quiz && _vm.questions.length)?_c('TestingPage',{attrs:{"quiz":_vm.quiz,"questions":_vm.questions,"current-index":_vm.currentIndex,"answers":_vm.answers,"locked":_vm.locked},on:{"select-option":_vm.onSelect}}):_c('div',{staticClass:"loading-screen"},[_c('div',{staticClass:"spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }